import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';
import { CompetitionRoutes } from './competition/routes';
import { TournamentRoutes } from './tournament/routes';
import { TourRoutes } from './tour/routes';
import { PlayersRoutes } from './players/routes';
import { MatchRoutes } from './match/routes';
import { SeasonTeamRoutes } from './seasonTeam/routes';
import { PersonRoutes } from './Person/routes';
import { PlayerRankingRoutes } from './PlayerRanking/routes';
import { TeamRankingRoutes } from './TeamRanking/routes';

const GuidePage = lazy(() => import('./Guide/GuidePage'));

export function CricketRoutes() {
  return (
    <Suspense fallback={<>...</>}>
      <CompetitionRoutes />
      <TournamentRoutes />
      <TourRoutes />
      <PlayersRoutes />
      <MatchRoutes />
      <SeasonTeamRoutes />
      <PersonRoutes />
      <PlayerRankingRoutes />
      <TeamRankingRoutes />
      <Routes>
        <Route
          path={Pages.sports.cricket.guide.meta.path}
          element={<GuidePage />}
        />
      </Routes>
    </Suspense>
  );
}
